import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Navbar from '../../Navbar';
import Coins from '../../../assets/img/coins.svg';
import Next from '../../../assets/img/next.svg';
import Previous from '../../../assets/img/previous.svg';
import { gameActions, profileActions } from '../../../actions';
import { showToast } from '../../../services';
import { useLoggedUser } from '../../../hooks/useLoggedUser';
import Close from '../../../assets/img/close.svg';

const PurchaseGame = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const loggedUser = useLoggedUser();

  if (!loggedUser?.data?.StudentProfileID) {
    history.replace('/login');
    return null;
  }

  const { games, blockedstatus, gamesLoading, blockedStatusLoading, hasLoadedGames, hasLoadedBlockedStatus } = useSelector((state) => state.games);
  const [currentPage, setCurrentPage] = useState(1);
  const gamesPerPage = 14;
  const [selectedGame, setSelectedGame] = useState(null);
  const [gamePurchased, setGamePurchased] = useState(false);

  useEffect(() => {
    dispatch(gameActions.fetchGames(loggedUser.data.StudentProfileID, loggedUser.data.GameMenu));
    dispatch(gameActions.fetchBlockedStatus(loggedUser.data.StudentProfileID));
  }, [dispatch]);

  useEffect(() => {
    if (selectedGame || gamePurchased) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
    return () => document.body.classList.remove('modal-open');
  }, [selectedGame, gamePurchased]);

  const purchaseGame = (gameType, gameId, paidCoins) => {
    dispatch(gameActions.purchaseGame({
      GameType: gameType,
      GameID: gameId,
      StudentProfileID: loggedUser.data.StudentProfileID,
      PaidCoinCount: paidCoins
    }))
      .then((response) => {
        if (response?.responseMessage === "You dont have enough coins to purchase this game") {
          showToast(response.responseMessage, 'warn');
          return;
        }
        dispatch(gameActions.fetchGames(loggedUser.data.StudentProfileID, loggedUser.data.GameMenu));
        dispatch(profileActions.fetchMypoints(loggedUser.data.StudentProfileID));
        setGamePurchased(true);
      })
      .catch((error) => {
        showToast(error, 'error');
        setGamePurchased(false);
      });
  };

  const handleGameClick = (game) => {
    setSelectedGame(game); // Open modal for unpurchased paid games
  };

  const confirmPurchase = () => {
    if (selectedGame) {
      purchaseGame(selectedGame.GameType, selectedGame.GameID, selectedGame.GamePrice);
      setSelectedGame(null); // Close the modal after purchase
    }
  };

  // Filter only unpurchased paid games
  const filteredGames = games.filter(
    (game) => game.GameType === "paid" && game.isPurchased !== "Y"
  );

  // Pagination setup
  const startIndex = (currentPage - 1) * gamesPerPage;
  const paginatedGames = filteredGames.slice(startIndex, startIndex + gamesPerPage);

  const LoadNextPage = () => {
    if (startIndex + gamesPerPage < filteredGames.length) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const LoadPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  const showBlockedStatusLoading = blockedStatusLoading && !hasLoadedBlockedStatus;
  const showGamesLoading = gamesLoading && !hasLoadedGames;

  return (
    <React.Fragment>
      <div className="container-fluid games-btn-page">
        <Navbar />
        <div className="content" id="content">
          <div className="d-flex justify-content-center align-items-center flex-column">
            <h2 className="b-font game-mm-h main-heading-top">
              {loggedUser.data.BlockGame} Purchase Game
            </h2>

            {showBlockedStatusLoading ? (
              <div className='blocked-msg'>Loading...</div>
            ) : blockedstatus?.BlockGame ? (
              <div className='blocked-msg'>
                You have been blocked from the game. Please contact your admin to regain access.
              </div>
            ) : (
              <>
                <div className="game-btns-cont w-100 d-flex flex-column align-items-center mt-1">
                  {showGamesLoading ? (
                    <div className='blocked-msg'>Loading...</div>
                  ) : Array.isArray(paginatedGames) && paginatedGames.length > 0 ? (
                    <>
                      {(() => {
                        const rows = [];
                        let index = 0;
                        let isOddRow = true;

                        while (index < paginatedGames.length) {
                          const gamesPerRow = isOddRow ? 3 : 4;
                          const rowGames = paginatedGames.slice(index, index + gamesPerRow);
                          index += gamesPerRow;
                          isOddRow = !isOddRow;

                          rows.push(
                            <div
                              className={`row d-flex align-items-center justify-content-center mt-1 ${gamesPerRow === 3 ? "w-75" : "w-100"}`}
                              key={`row-${index}`}
                            >
                              {rowGames.map((game) => (
                                <div
                                  className={`slct-gme ${gamesPerRow === 3 ? "col-sm-4 col-lg-4 col-md-4" : "col-sm-3 col-lg-3 col-md-3"}`}
                                  key={game.GameID}
                                >
                                  <div
                                    className="d-flex flex-row align-items-center slct-gme-div justify-content-center"
                                    onClick={() => handleGameClick(game)}
                                  >
                                    <label className="slct-gm-name text-center buying-gme">
                                      {game.GameName}
                                    </label>
                                    <div className="gm-cns-div">
                                      <div className="gm-cns">
                                        <img src={Coins} className="w-50" alt="Coins" />
                                        <label className="game-coins">Buy</label>
                                      </div>
                                    </div>
                                  </div>
                                  <h3 className="s-g-text mt-1 text-center">
                                    {game.GamePrice} coins
                                  </h3>
                                </div>
                              ))}
                            </div>
                          );
                        }
                        return rows;
                      })()}
                    </>
                  ) : (
                    <div>{hasLoadedGames ? 'No paid games available for purchase.' : 'Loading...'}</div>
                  )}
                </div>

                <div className='gme-q-pn-left d-flex align-items-center justify-content-between p-2'>
                  <div>
                    {currentPage > 1 && (
                      <img src={Previous} onClick={LoadPreviousPage} alt="Previous" />
                    )}
                  </div>
                </div>
                <div className='gme-q-pn-right d-flex align-items-center justify-content-between p-2'>
                  <div>
                    {startIndex + gamesPerPage < filteredGames.length && (
                      <img src={Next} onClick={LoadNextPage} alt="Next" />
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>

        {/* Modal for confirming game purchase */}
        {selectedGame && (
          <div className="modal alrt-mdl" id="alert-modal" style={{ display: 'block' }}>
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body ad-modal pt-5">
                  <div className="w-100 d-flex align-items-center justify-content-center">
                    <label className='b-font alt-label'>
                      Are you sure you want to purchase this game?
                    </label>
                  </div>
                  <div className="pl-5 mt-4 mb-4 d-flex align-items-center justify-content-between">
                    <button className="accept-btn mt-2" onClick={confirmPurchase} data-bs-dismiss="modal">Yes</button>
                    <button className="accept-btn no mt-2" onClick={() => setSelectedGame(null)} data-bs-dismiss="modal">No</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Modal for game purchase success */}
        {gamePurchased && (
          <div className="modal alrt-mdl" id="alert-modal" style={{ display: 'block' }}>
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body ad-modal pt-5">
                  <div className="w-100 d-flex align-items-center justify-content-center">
                    <label className='b-font alt-label'>
                      Success! The purchased game has been added to the Game Menu.
                    </label>
                  </div>
                  <div className="pl-5 mt-4 mb-4 d-flex align-items-center justify-content-between">
                    <button className="accept-btn pull-right mt-2" onClick={() => setGamePurchased(false)} data-bs-dismiss="modal">Ok</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

      </div>
    </React.Fragment>
  );
};

export default PurchaseGame;
